"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockBondOffer = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const types_1 = require("../../types");
const getMockBondOffer = () => {
    return {
        hadoMarket: new anchor_1.web3.PublicKey('9mCw8UDAV1w3UcrASDisGF4y3QZxAQXMRtYCJVQNiTsn'),
        pairState: types_1.PairState.PerpetualOnMarket,
        bondingCurve: { delta: new anchor_1.BN(0), bondingType: types_1.BondingCurveType.Linear },
        baseSpotPrice: new anchor_1.BN(1000000000),
        mathCounter: new anchor_1.BN(0),
        currentSpotPrice: new anchor_1.BN(500000000),
        concentrationIndex: new anchor_1.BN(0),
        bidCap: new anchor_1.BN(0),
        bidSettlement: new anchor_1.BN(-99999000000000),
        edgeSettlement: new anchor_1.BN(1000000000),
        fundsSolOrTokenBalance: new anchor_1.BN(3000000000),
        buyOrdersQuantity: new anchor_1.BN(1),
        lastTransactedAt: new anchor_1.BN(1692149055),
        assetReceiver: new anchor_1.web3.PublicKey('6CnQUFVk2d8TRvQa2Lr7KDvx9zK12Q4jkA7mmDtzj71e'),
        validation: {
            loanToValueFilter: new anchor_1.BN(0),
            collateralsPerToken: new anchor_1.BN(0),
            maxReturnAmountFilter: new anchor_1.BN(0),
            bondFeatures: types_1.BondFeatures.AutoReceiveAndReceiveNft,
        },
        publicKey: new anchor_1.web3.PublicKey('5mxSZxG9JSwWG9bf3rVG2jC4GyDqemdF9gKQM4AKSpGw'),
        loanApr: new anchor_1.BN(0),
        liquidationLtvBp: new anchor_1.BN(0),
        offerLtvBp: new anchor_1.BN(0)
    };
};
exports.getMockBondOffer = getMockBondOffer;
